import type { FaireProductEntity } from "../../entity_types/product";

export const p_jubjgj7vt3: FaireProductEntity = {
  token: "p_jubjgj7vt3",
  type: "product",
  name: "Waffle Knit Blanket - Special Offer",
  brandToken: "b_bnhmto92d6",
  brandName: "Whisper Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/8a864aab26c709e93fd23f3ad9d83f933ddf743e18c40c1d5e0c36677fdd01c2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/449baff7f8d8d85e28c476256d814715b6fc539a738009857595c0876525e693.jpeg",
    "https://cdn.faire.com/fastly/3377021b2e2b1eb1114417ab9b955348533320e6a761858952a454aace447e41.jpeg",
    "https://cdn.faire.com/fastly/b223826f2e8c52923fffd20e753764d5ce3a9b967db0f8edb120af7b75d3ea0a.jpeg",
    "https://cdn.faire.com/fastly/dd8f94fc5c0742bca71000db14c58aef42f754b113961e410d244a0a121a9fcb.jpeg",
    "https://cdn.faire.com/fastly/6eea9354070a548dbb3b5c42e0cf87691cfb5b13de0b2ab0b1e6a33a39600732.jpeg",
    "https://cdn.faire.com/fastly/3e9d11f3fc2adc847566f4807482e66ce37dd59af3ef22013fdc2efc1de78965.jpeg",
    "https://cdn.faire.com/fastly/253ed5a3439c3f2591a7417fc0f025bf7fd497c0baeefeeb1af0d505cd0f9346.jpeg",
  ],
  priceDollars: 56.99,
  description:
    "In a Nutshell\n\n * 100% GOTS-Certified & Fairtrade-Certified organic cotton \n * Made in India \n * 320 GSM waffle weave — breathable, lightweight, and sweat-resistant \n * Naturally cooling design for airflow and year-round comfort \n * Elegant waffle knit texture \n * Non-toxic, hypoallergenic, naturally breathable and cooling \n * Shrink-resistant and snag-free construction \n * Easy Care, Machine Washable \n\n\n\nIncludes\n\n * 1 Organic Cotton Waffle Blanket \n\n\n\n See It's All in the Details for full product specs below \n",
  tags: [],
  msrpDollars: 74.08,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:04.679Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
